import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=350cb808"
import script from "./LogoutBtn.vue?vue&type=script&lang=js"
export * from "./LogoutBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports